import styled from "styled-components";

export const ProfileContainerStyled = styled.div`
  padding: 20px 16px 40px 16px;
  .breadcrumb_layout {
    margin-bottom: 24px;
  }
  .profile_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    .profile_detail {
      padding: 0 16px;
      .avatar_wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 25px;
        .avatar {
          width: 82.56px;
          height: 82.56px;
          border-radius: 50%;
        }
      }
    }
    .my_reward_title {
      padding: 16px 20px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
    }
    .booking_layout {
      margin-bottom: 20px;
      padding: 0 20px;
    }
    .my_reward_card_wrap {
      padding: 0px 20px;
      display: flex;
      flex-wrap: wrap;
      column-gap: 18px;
      .my_reward_card {
        margin-bottom: 26px;
        flex-basis: calc(50% - 9px);
        overflow: hidden;
        &:last-child {
          margin-bottom: 0px;
        }
      }
    }
    .interested_sec {
      padding: 0px 12.5px 0px 12.5px;
    }

    .modal_delete {
      padding: 50px;
      border-radius: 20px;
      background: ${({ theme }) => theme.COLORS.WHITE_1};
      .title {
        margin-bottom: 20px;
      }
      .btn_wrap {
        display: flex;
        justify-content: flex-end;
        column-gap: 20px;
        .btn {
          width: 150px;
        }
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 32px 20px 40px 20px;
    .breadcrumb_layout {
      display: none;
    }
  }
`;
